import "components/General/Appearance.css"
import "components/Spotlight/Spotlight_Common.css"
import "components/Content/Toolbar/CSS Files/Toolbar.css"
import React, {Component} from "react"

import UploadsToggle from "components/Content/Toolbar/Uploads"
import ImageToggle from "components/Content/Toolbar/Data_Retrieval/loadStockImages"
import BackgroundsToggle from "components/Content/Toolbar/Background"
import StickersToggle from "components/Content/Toolbar/Data_Retrieval/loadStickers"
import TextToggle from "components/Content/Toolbar/Text"
import PhotoAlbumToggle from "components/Content/Toolbar/Data_Retrieval/loadPhotoAlbum"
import DraftsToggle from "components/Content/Toolbar/Drafts"
import ShapeToggle from "components/Content/Toolbar/Shapes"


import Draft from "../../../site_media/images/Drafts-Icon.png"
import PhotoAlbum from "../../../site_media/images/Photo-Album-Icon.png"
import Shapes from "../../../site_media/images/Shape-Icon.png"
import StockImages from "../../../site_media/images/Stock-Images-Icon.png"
import Upload from "../../../site_media/images/upload.png"
import Background from"../../../site_media/images/background.png"
import Sticker from"../../../site_media/images/Sticker.png"
import Text from"../../../site_media/images/text3.png"
import { FaPencilAlt } from "react-icons/fa";
import ReactDOM from "react-dom";


class Toolbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showText: false,
            showUploads: false,
            showImages: false,
            showBackgrounds: false,
            showStickers: false,
            showPhotoAlbum: false,
            showDrafts:false,
            showShapes:false,

        };

        this.setShowText = this.setShowText.bind(this);
        this.setShowUploads = this.setShowUploads.bind(this);
        this.setShowImages = this.setShowImages.bind(this);
        this.setShowBackgrounds = this.setShowBackgrounds.bind(this);
        this.setShowStickers = this.setShowStickers.bind(this);
        // this.setShowPhotoAlbum = this.setShowPhotoAlbum.bind(this);
        this.setShowDrafts = this.setShowDrafts.bind(this);
        this.setShowShapes = this.setShowShapes.bind(this);
        this.clearToggleBar = this.clearToggleBar.bind(this);
    }

    setShowShapes() {
        this.setState ({
            showText: false,
            showUploads: false,
            showImages: false,
            showBackgrounds: false,
            showStickers: false,
            showPhotoAlbum: false,
            showDrafts:false,
            showShapes:true,
        });
    }

    setShowText() {
        this.setState ({
            showText: true,
            showUploads: false,
            showImages: false,
            showBackgrounds: false,
            showStickers: false,
            showPhotoAlbum: false,
            showDrafts:false,
            showShapes:false,

        });
    }

    setShowUploads () {
        this.setState ({
            showUploads: true,
            showText: false,
            showImages: false,
            showBackgrounds: false,
            showStickers: false,
            showPhotoAlbum: false,
            showDrafts:false,
            showShapes:false,


        });
    }

    setShowImages () {
        this.setState ({
            showImages: true,
            showText: false,
            showUploads: false,
            showBackgrounds: false,
            showStickers: false,
            showPhotoAlbum: false,
            showDrafts:false,
            showShapes:false,
        });
    }

    setShowBackgrounds () {
        this.setState ({
            showBackgrounds: true,
            showText: false,
            showUploads: false,
            showImages: false,
            showStickers: false,
            showPhotoAlbum: false,
            showDrafts:false,
            showShapes:false,
        });
    }

    setShowStickers () {
        this.setState ({
            showStickers: true,
            showText: false,
            showUploads: false,
            showImages: false,
            showBackgrounds: false,
            showPhotoAlbum: false,
            showDrafts:false,
            showShapes:false,
        });
    }

    // setShowPhotoAlbum () {
    //     this.setState ({
    //         showPhotoAlbum: true,
    //         showText: false,
    //         showUploads: false,
    //         showImages: false,
    //         showBackgrounds: false,
    //         showStickers: false,
    //         showDrafts:false,
    //         showShapes:false,
    //     });
    // }

    setShowDrafts() {
        this.setState ({
            showPhotoAlbum: false,
            showText: false,
            showUploads: false,
            showImages: false,
            showBackgrounds: false,
            showStickers: false,
            showDrafts:true,
            showShapes:false,
        });
    }


    clearToggleBar (){
        this.setState ({
            showText: false,
            showUploads: false,
            showImages: false,
            showBackgrounds: false,
            showStickers: false,
            showPhotoAlbum: false,
            showDrafts:false,
            showShapes:false,
        });
    }
    componentDidMount(){
        if(this.props.fileData == null){
            this.setShowDrafts();
        }
        else if(this.props.fileData){
            this.setShowUploads();
        }
    }
    render() {
        return (
            <div className="tool-bar customscrolltoolbar">
                <div id= "toolbar1"
                    className="button-holder">
                    <button
                        className = "nav-icon"
                        onClick = {this.setShowUploads}>
                        <img src={Upload} alt='Nav Icon' />
                        <h1 className= "nav-icon-text">
                            Uploads
                        </h1>
                    </button>

                    <button
                        className = "nav-icon"
                        onClick = {this.setShowImages}>
                        <img  src={StockImages} alt='Stock Images'/>
                        <h1 className= "nav-icon-text">
                            Stock Images
                        </h1>
                    </button>

                    {/* <button
                        className = "nav-icon"
                        onClick = {this.setShowPhotoAlbum}>
                        <img src={PhotoAlbum} alt='Album'/>
                        <h1 className= "nav-icon-text">
                            Photo Album
                        </h1>
                    </button> */}

                    <button
                        className = "nav-icon"
                        onClick = {this.setShowDrafts}>
                        <img src={Draft} alt='Darafts' />
                        <h1 className= "nav-icon-text">
                            Drafts
                        </h1>
                    </button>

                    <button
                        className = "nav-icon"
                        onClick = {this.setShowBackgrounds}>
                        <img  src={Background}/>
                        <h1 className= "nav-icon-text">
                            Background
                        </h1>
                    </button>

                    <button
                        className = "nav-icon"
                         onClick = {this.setShowShapes}>
                        <img  src={Shapes}/>
                        <h1 className= "nav-icon-text">
                            Shapes
                        </h1>
                    </button>

                    <button
                        className = "nav-icon"
                        onClick = {this.setShowText}>
                        <img  src={Text}/>
                        <h1 className= "nav-icon-text">
                            Text
                        </h1>
                    </button>

                    <button
                        className = "nav-icon"
                        onClick = {this.setShowStickers}>
                        <img  src={Sticker}/>
                        <h1 className= "nav-icon-text">
                            Stickers
                        </h1>
                    </button>


               </div>
                {
                    this.state.showText ?
                        <TextToggle/> :
                        null
                }
                {
                    this.state.showUploads ?
                        <UploadsToggle/> :
                        null
                }
                {
                    this.state.showImages ?
                        <ImageToggle/> :
                        null
                }
                {
                    this.state.showBackgrounds ?
                        <BackgroundsToggle/> :
                        null
                }
                {
                    this.state.showStickers ?
                        <StickersToggle/> :
                        null
                }

                {
                    this.state.showPhotoAlbum ?
                        <PhotoAlbumToggle/> :
                        null
                }
                {
                    this.state.showDrafts ?
                        <DraftsToggle/> :
                        null
                }
                {
                    this.state.showShapes ?
                        <ShapeToggle/> :
                        null
                }
            </div>
        );
    }
}

export default Toolbar;


